export const globalColors = {
  disabledColor: "#C4C4C4",
  selectedColor: "#EDF4FB",
  preview: "#7360F2",
  share: "#7360F2",
  openForm: "#a448ce",
  saveChanges: "#65A0BA",
  primary: "#43425D",
  primaryTextColor: "#4D4F5C",
  logoBackground: "#14274E",
  calmLight: "#F7FAFC",
  calmLightDark: "#65A0BA",
  backgroundGrey: "#F4F4F4",
  backgroundLightGrey: "#E8E8E9",
  textBoxBackgroundGrey: "#F6F1F1",
  textGrey: "#77787A",
  textLightGrey: "#9C9C9C",
  white: "#ffffff",
  headingBlack: "#1C1D1F",
  hoverColor: "#DFDFE0",
  lightHoverColor: "#0000000a",
  cardBackgroundColor: "#ebebee",
  errorColor: "#fb6868",
  iconColors: {
    clear: "#7575df",
    delete: "#fb6868",
    publish: "#008cff",
    moveToDraft: "#008cff",
  },
};
